<template>
    <div id="main-page">
        <div class="container banners__container">
            <h1 class="title mb-32" v-html="seo_h1"></h1>
        </div>
        <div class="container banners__container">
            <div class="banners" v-if="banners">
                <div class="banner banner-1">
                    <a rel="noopener" :href="banners[0].link" target="_blank" v-if="banners[0].link.includes( 'http')">
                        <img :src="'/storage/' + banners[0].image" alt="Баннер со специальным предложением на сервисе фотопроката MRental">
                    </a>
                    <router-link v-else :to="banners[0].link">
                        <img :src="'/storage/' + banners[0].image" alt="Баннер со специальным предложением на сервисе фотопроката MRental">
                    </router-link>
                </div>
                <div class="banner banner-2" v-if="banners[1]">
                    <a rel="noopener" :href="banners[1].link" target="_blank" v-if="banners[1].link.includes( 'http')">
                        <img :src="'/storage/' + banners[1].image" alt="Баннер со специальным предложением на сервисе фотопроката MRental">
                    </a>
                    <router-link v-else :to="banners[1].link">
                        <img :src="'/storage/' + banners[1].image" alt="Баннер со специальным предложением на сервисе фотопроката MRental">
                    </router-link>
                </div>
                <div class="banner banner-3" v-if="banners[2]">
                    <a rel="noopener" :href="banners[2].link" target="_blank" v-if="banners[2].link.includes( 'http')">
                        <img :src="'/storage/' + banners[2].image" alt="Баннер со специальным предложением на сервисе фотопроката MRental">
                    </a>
                    <router-link v-else :to="banners[2].link">
                        <img :src="'/storage/' + banners[2].image" alt="Баннер со специальным предложением на сервисе фотопроката MRental">
                    </router-link>
                </div>
            </div>

            <div class="d-block d-md-none" v-if="banners">
                <carousel :items="1" :nav="false" :dots="true">
                    <div v-for="banner in banners">
                        <a rel="noopener" :href="banner.link" v-if="banner.link.includes( 'http')" target="_blank"><img :src="'/storage/' + banner.image" alt="Баннер со специальным предложением на сервисе фотопроката MRental"></a>
                        <router-link :to="banner.link" v-else><img :src="'/storage/' + banner.image" alt="Баннер со специальным предложением на сервисе фотопроката MRental"></router-link>
                    </div>
                </carousel>
                <hr>
            </div>
        </div>

        <div class="container mb-32 new-tabs">
            <div class="d-flex align-items-center justify-content-between new-tabs-titles-wrapper">
                <div class="new-tabs-titles">
                    <div class="new-tabs-title" :class="{'active': new_active == 1}" @click="new_active = 1">
                        <span class="title-2 mb-0">Новинки камер</span>
                    </div>
                    <div class="new-tabs-title" :class="{'active': new_active == 2}" @click="new_active = 2">
                        <span class="title-2 mb-0">Новинки света</span>
                    </div>
                </div>
            </div>
            <div class="title-4 mb-0 link-catalog-wrapper">
                <router-link class="link-catalog" to="/catalog/new">Перейти в каталог</router-link>
            </div>
            <div class="new-tabs-content-wrapper new-tabs-content-wrapper-mtn">
                <div class="new-tabs-content">
                    <div class="new-tab-content" :class="{'active-content': new_active == 1}">
                        <div class="catalog-container">
                            <div class="news-product" v-if="new_photo_products">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:true},
                            535:{items:3,nav:false,margin:7,dots:true},
                            820:{items:4,nav:false,margin:7,dots:true},
                            991:{items:5,nav:false,margin:7,dots:true},
                            1200:{items:6,nav:true,margin:7,dots:false}}">
                                    <catalog-card v-for="(item, i) in new_photo_products" :key="i" :item="item"></catalog-card>
                                </carousel>
                            </div>
                        </div>
                    </div>
                    <div class="new-tab-content" :class="{'active-content': new_active == 2}">
                        <div class="catalog-container">
                            <div class="news-product" v-if="new_kino_products">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:true},
                                535:{items:3,nav:false,margin:7,dots:true},
                                820:{items:4,nav:false,margin:7,dots:true},
                                991:{items:5,nav:false,margin:7,dots:true},
                                1200:{items:6,nav:true,margin:7,dots:false}}">
                                    <catalog-card v-for="(item, i) in new_kino_products" :key="i" :item="item"></catalog-card>
                                </carousel>
                            </div>
                        </div>
                    <div>
                </div>
            </div>
                </div>
            </div>

        </div>
        <div class="container mb-32 new-tabs">

            <div class="d-flex align-items-center justify-content-between new-tabs-titles-wrapper">
                <div class="new-tabs-titles">
                    <div class="new-tabs-title active-other">
                        <span class="title-2 mb-0">Готовые комплекты</span>
                    </div>
                </div>
            </div>
            <div class="title-4 mb-0 link-catalog-wrapper link-catalog-wrapper-second">
                <router-link class="link-catalog" to="/catalog/category/gotovye-komplekty">Перейти в каталог</router-link>
            </div>
            <div class="new-tabs-content-wrapper">
                <div class="new-tabs-content">
                    <div class="new-tab-content active-content">
                        <div class="catalog-container">
                            <div class="news-product" v-if="complect_product">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:true},
                                                        535:{items:3,nav:false,margin:7,dots:true},
                                                        820:{items:4,nav:false,margin:7,dots:true},
                                                        991:{items:5,nav:false,margin:7,dots:true},
                                                        1200:{items:6,nav:true,margin:7,dots:false}}">
                                    <catalog-card v-for="(item, i) in complect_product" :key="i" :item="item"></catalog-card>
                                </carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mb-32 new-tabs" v-for="category in categories_nova">

            <div class="d-flex align-items-center justify-content-between new-tabs-titles-wrapper">
                <div class="new-tabs-titles">
                    <div class="new-tabs-title active-other">
                        <span class="title-2 mb-0">{{category.title}}</span>
                    </div>
                </div>
            </div>
            <div class="title-4 mb-0 link-catalog-wrapper link-catalog-wrapper-second">
                <router-link class="link-catalog" :to="'/catalog/category/' + category.cat_slug">Перейти в каталог</router-link>
            </div>
            <div class="new-tabs-content-wrapper">
                <div class="new-tabs-content">
                    <div class="new-tab-content active-content">
                        <div class="catalog-container">
                            <div class="news-product" v-if="category.subcategories">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:true},
                                535:{items:3,nav:false,margin:7,dots:true},
                                820:{items:4,nav:false,margin:7,dots:true},
                                991:{items:5,nav:false,margin:7,dots:true},
                                1200:{items:6,nav:true,margin:7,dots:false}}">
                                    <sub-category-nova-card v-for="(item, i) in category.subcategories" :key="i" :item="item" :slug="category.cat_slug"></sub-category-nova-card>
                                </carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container d-none d-xl-block">
            <hr>
        </div>
        <div class="container d-none d-xl-block" v-if="benefits">
            <h2 class="as-h1 mb-32">Наши преимущества</h2>
            <div class="benefits">
                <div class="benefit" v-for="(item, i) in benefits" :key="i" >
                    <img class="back-benfit" :src="'/storage/' + item.image" :alt="item.name + ' на сервисе фотопраката MRental'">
                    <div class="gradient"></div>
                    <div class="ico-benefits">
                        <img :src="'/storage/' + item.icon" :alt="item.name + ' на сервисе фотопраката MRental'">
                    </div>
                    <span class="title-3">{{item.name}}</span>
                    <p>{{item.text}}</p>
                </div>
            </div>
        </div>

        <div class="container">
            <hr>
        </div>

        <div class="container">
            <div class="card-client" :style="{ backgroundImage: `url(${second_banner.image})` }">
                <div class="row">
                    <div class="col-xl-6">
                        <div v-html="second_banner.text"></div>
<!--                        <h3>Зарегистрируйся и получи карту клиента!</h3>-->
<!--                        <h4 class="mb-12">Что дает карта?</h4>-->
<!--                        <ul class="mb-24">-->
<!--                            <li>Аренда техники без залога</li>-->
<!--                            <li>Скидка в размере 5%</li>-->
<!--                            <li>Скидка в размере 10% - студентам дневной формы</li>-->
<!--                            <li>Скидка в размере 20% - студентам киновузов художки</li>-->
<!--                            <li>Скидка в размере 50% - во время прохождения обучения на курсах kinoschool.by</li>-->
<!--                        </ul>-->
                        <div>
                            <router-link to="/rules/skidki" class="button btn-small btn-v2">Читать далее</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <hr>
            <div class="clients"  v-if="clients">
                <h2 class="as-h1 mb-32">Наши клиенты</h2>
                <carousel :responsive="{0:{items:3,nav:false,margin:6,dots:true},
                    575:{items:4,nav:false,margin:6,dots:true},
                    900:{items:5,nav:false,margin:7,dots:true},
                    1200:{items:6,nav:true,margin:30,dots:false}}">
                    <a rel="nofollow" class="client-slide" v-for="(item, i) in clients" :key="i" target="_blank" :href="item.link">
                        <img :src="'/storage/' + item.image" alt="Логотип клиента фотопраката MRental">
                    </a>
                </carousel>
            </div>
            <hr>
            <div class="partners" v-if="partners">
                <h2 class="as-h1 mb-32">Наши партнеры</h2>
                <carousel :responsive="{0:{items:3,nav:false,margin:6,dots:true},
                    575:{items:4,nav:false,margin:6,dots:true},
                    900:{items:5,nav:false,margin:7,dots:true},
                    1200:{items:6,nav:true,margin:30,dots:false}}">
                    <a rel="nofollow" class="partner-slide" v-for="(item, i) in partners" :key="i" target="_blank" :href="item.link">
                        <img :src="'/storage/' + item.image" alt="Логотип партнера фотопраката MRental">
                    </a>
                </carousel>
            </div>

            <hr>
            <div class="container-news">
                <h2 class="as-h1 mb-32">Новости</h2>
                <div class="grid-container">
                    <div class="box-grid" v-for="item in news_bd"
                         v-bind:key="news_bd.id">
                        <news-app :item="item"></news-app>
                    </div>
                </div>
                <router-link to="/news" class="to-all-items">Все новости</router-link>
            </div>

            <div class="mt-5" v-if="seo_text">
                <p v-html="seo_text"></p>
            </div>
        </div>
    </div>
</template>

<script>

    import carousel from "vue-owl-carousel";

    export default {
        components: {carousel},

        data() {
            return {
                categories_nova: null,
                news_bd: null,
                new_active: 1,
                new_photo_products: null,
                new_kino_products: null,
                complect_product: null,
                banners: null,
                clients: null,
                partners: null,
                benefits: null,
                second_banner: null,
                slide: 0,
                seo_text:null,
                seo_h1:null
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let url = '/api/main-page';
                axios.get(url)
                    .then(response => {
                        this.news_bd = response.data.news;
                        this.categories_nova = response.data.categories_nova;
                        this.new_photo_products = response.data.new_photo_products;
                        this.new_kino_products = response.data.new_kino_products;
                        this.complect_product = response.data.complect_products;
                        this.banners = response.data.banners;
                        this.clients = response.data.clients;
                        this.partners = response.data.partners;
                        this.benefits = response.data.benefits;
                        this.second_banner = response.data.second_banner;
                        this.second_banner.image = '/storage/' + this.second_banner.image;

                        let seoInfo = response.data.seoInfo
                        this.seo_text = seoInfo.seo_text
                        this.seo_h1 = seoInfo.seo_h1

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Фотопрокат "MRental" - прокат фото, видео и кинотехники в Минске без залога.';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Прокат фото, видео, кинотехники и оборудования в Минске, Фотопрокат "MRental".';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                        document.querySelector('meta[property="og:type"]').setAttribute("content",  'og:website');
                        document.querySelector('meta[property="og:title"]').setAttribute("content",  seoInfo?.seo_title ? seoInfo?.seo_title : 'Фотопрокат "MRental" - прокат фото, видео и кинотехники в Минске без залога.');
                        document.querySelector('meta[property="og:image"]').setAttribute("content",  window.location.origin + '/img/og_image_main.png');
                        document.querySelector('meta[property="og:url"]').setAttribute("content", window.location.href );
                    })
            },
        }
    }
</script>
